export default {
  homepage: {
    topDealsTag: "b2492fc7-748b-4796-98fe-1e35a0c7c4e1",
    topDeals: "Onze topdeals",
    currentDealsTitle: "Nieuwste deals",
    currentDealsSubline:
      "Alle aanbiedingen voor een goedkope vakantie in één overzicht",
    buttonText: "Naar de deals",

    tagSection_1_tagImage: "/assets/images/home-mood/tag_flexcancel",
    tagSection_1_tagId: "318519dd-df88-49bc-8f60-c5a2c92cfdd0",
    tagSection_1_title: "Zonvakantie",
    tagSection_1_subline: "De leukste Zonvakantie aanbiedingen",

    tagSection_2_tagImage: "/assets/images/home-mood/destination_netherlands",
    tagSection_2_tagId: "d166a846-b398-43cf-9507-4e7244f4dc0e",
    tagSection_2_title: "Nederland vakantie",
    tagSection_2_subline:
      "Hotelaanbiedingen en weekendjes weg voor een reis in eigen land",

    tagSection_3_tagImage: "/assets/images/home-mood/tag_weekend",
    tagSection_3_tagId: "bfd9fa0f-0fc5-44d9-a4c3-4bac00415ee0",
    tagSection_3_title: "Weekendje weg",
    tagSection_3_subline: "De mooiste weekendjes weg vind je hier",

    partnerSection_link: "https://hotels.holidayguru.nl/",
    partnerSection_title: "Hotels zoeken",
    partnerSection_subline: "De mooiste weekendjes weg vind je hier",
    noMoreDealsInfo: "geen verdere aanbiedingen beschikbaar"
  },
  supportPersonImageSrc: "/assets/images/callcenter/jeroen.jpg",

  magazine: {
    section: {
      link: "https://www.holidayguru.nl/magazine/",
      image: "/assets/images/magazine/nl.jpg"
    }
  },

  raffle: {
    link: "https://www.holidayguru.nl/paas-winactie-meedoen/ "
  },

  dealSearch: {
    placeholder: "Waar wil je heen?",
    categoryLabel: "Kies een categorie"
  },

  partnerList: {
    headline: "Vind jouw perfecte vakantie",
    subline: "",
    data: [
      // {
      //   label: 'Flashdeals',
      //   sub: 'Exclusieve deals - slechts korte tijd beschikbaar',
      //   url: 'https://flashdeals.holidayguru.nl/resultaten',
      //   image:
      // image: '/assets/images/teasercards/Kachel_WL_368x180_kurzreisen.png',
      // },
      {
        label: "Zonvakantie",
        sub: "De beste zonvakantie aanbiedingen",
        url: "https://www.holidayguru.nl/zonvakantie/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_pauschalreisen.png"
      },
      {
        label: "Vluchten",
        sub: "Goedkope vliegtickets",
        url: "https://www.holidayguru.nl/vluchten-zoeken/#/flights",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fluege.png"
      },
      {
        label: "Bestemmingen",
        sub: "De populairste bestemmingen",
        url: "https://www.holidayguru.nl/vakantiebestemmingen/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png"
      },
      {
        label: "Huisjes met hottub",
        sub: "",
        url: "https://www.holidayguru.nl/huisje-hottub/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_jacuzzi.png"
      },
      {
        label: "Vakantiehuizen met zwembad",
        sub: "",
        url: "https://www.holidayguru.nl/vakantiehuis-met-prive-zwembad-nederland/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_Vakantiehuizen.png"
      },
      {
        label: "Top 10 Airbnb Nederland",
        sub: "",
        url: "https://www.holidayguru.nl/travel-magazine/airbnb-nederland/",
        image:
          "/assets/images/teasercards/Kachel_WL_368x180_airbnb_netherlands.png"
      }
      // {
      //   label: 'Last Minute',
      //   sub: 'Last minute aanbod voor de beste prijs',
      //   url: 'https://www.holidayguru.nl/last-minute/',
      //   image: '/assets/images/teasercards/Kachel_WL_368x180_fruehbucher.png',
      // },
      // {
      //   label: 'Stedentrips',
      //   sub: 'Citytrips met vlucht + hotel',
      //   url: 'https://holidayguru.bebsy.nl/stedentrip',
      //   image: '/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png',
      // },
      // {
      //   label: 'Wintersport',
      //   sub: 'Skivakanties - zo goedkoop zag je ze nog nooit',
      //   url: 'https://wintersport.holidayguru.nl/',
      //   image: '/assets/images/teasercards/Kachel_WL_368x180_skireisen.png',
      // },
      // {
      //   label: 'Hotels',
      //   sub: 'De perfecte overnachting',
      //   url: 'https://hotels.holidayguru.nl/',
      //   image: '/assets/images/teasercards/Kachel_WL_368x180_hotels.png',
      // },
      // {
      //   label: 'Huurauto',
      //   sub: "Goedkope huurauto's vergelijken",
      //   url: 'https://www.holidayguru.nl/huurauto/',
      //   image: '/assets/images/teasercards/Kachel_WL_368x180_mietwagen.png',
      // },
    ]
  },

  linkList: [
    {
      label: "Populaire bestemmingen",
      links: [
        {
          label: "Canarische Eilanden vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/canarische-eilanden/"
        },
        {
          label: "Curaçao vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/curacao/"
        },
        {
          label: "Duitsland vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/duitsland/"
        },
        {
          label: "Griekenland vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/griekenland/"
        },
        {
          label: "Ibiza vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/ibiza/"
        },
        {
          label: "Italië vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/italie/"
        },
        {
          label: "Spanje vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/spanje/"
        }
      ]
    },
    {
      label: "Dichtbij huis",
      links: [
        {
          label: "België vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/belgie/"
        },
        {
          label: "Nederland vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/nederland/"
        },
        {
          label: "Bijzondere overnachtingen",
          url: "https://www.holidayguru.nl/accommodatie/bijzondere-overnachtingen/"
        },
        {
          label: "Huisjes met hottub",
          url: "https://www.holidayguru.nl/accommodatie/huisje-hottub/"
        },
        {
          label: "Huisjes met zwembad",
          url: "https://www.holidayguru.nl/vakantiehuis-met-prive-zwembad-nederland/"
        },
        {
          label: "Privé sauna met overnachting",
          url: "https://www.holidayguru.nl/prive-sauna-met-overnachting/"
        },
        {
          label: "Weekendje weg aan zee",
          url: "https://www.holidayguru.nl/weekendje-weg/aan-zee/"
        }
      ]
    },
    {
      label: "Stedentrips",
      links: [
        {
          label: "Stedentrip",
          url: "https://www.holidayguru.nl/stedentrip/"
        },
        {
          label: "Stedentrip Barcelona",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/barcelona/"
        },
        {
          label: "Stedentrip Lissabon",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/lissabon/"
        },
        {
          label: "Stedentrip Londen",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/londen/"
        },
        {
          label: "Stedentrip New York",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/new-york/"
        },
        {
          label: "Stedentrip Praag",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/praag/"
        },
        {
          label: "Stedentrip Rome",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/rome/"
        }
      ]
    },
    {
      label: "Verre reizen",
      links: [
        {
          label: "Bali vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/bali/"
        },
        {
          label: "Dubai vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/dubai/"
        },
        {
          label: "Egypte vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/egypte/"
        },
        {
          label: "IJsland vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/ijsland/"
        },
        {
          label: "Kaapverdië vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/kaapverdie/"
        },
        {
          label: "Turkije vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/turkije/"
        },
        {
          label: "Verenigde Staten vakantie",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/verenigde-staten/ "
        }
      ]
    },
    {
      label: "Soort reis",
      links: [
        {
          label: "Hotels",
          url: "https://www.holidayguru.nl/hotels/"
        },
        {
          label: "Vluchten",
          url: "https://www.holidayguru.nl/vluchten/"
        },
        {
          label: "Vakanties",
          url: "https://www.holidayguru.nl/vakanties/"
        },
        {
          label: "All inclusive",
          url: "https://www.holidayguru.nl/all-inclusive/"
        },
        {
          label: "Weekendje weg",
          url: "https://www.holidayguru.nl/weekendje-weg/"
        },
        {
          label: "Verre reizen",
          url: "https://www.holidayguru.nl/verre-reizen/"
        },
        {
          label: "Zonvakanties",
          url: "https://www.holidayguru.nl/zonvakantie/"
        }
      ]
    },
    {
      label: "Last Minute",
      links: [
        {
          label: "Last minute",
          url: "https://www.holidayguru.nl/last-minute/"
        },
        {
          label: "Last minute Curaçao",
          url: "https://www.holidayguru.nl/last-minute/curacao/"
        },
        {
          label: "Last minute Egypte",
          url: "https://www.holidayguru.nl/last-minute/egypte/"
        },
        {
          label: "Last minute Griekenland",
          url: "https://www.holidayguru.nl/last-minute/griekenland/"
        },
        {
          label: "Last minute Nederland",
          url: "https://www.holidayguru.nl/last-minute/nederland/"
        },
        {
          label: "Last minute Spanje",
          url: "https://www.holidayguru.nl/last-minute/spanje/"
        },
        {
          label: "Last minute Turkije",
          url: "https://www.holidayguru.nl/last-minute/turkije/"
        }
      ]
    },
    {
      label: "Specials",
      links: [
        {
          label: "Disneyland Parijs aanbiedingen",
          url: "https://www.holidayguru.nl/disneyland-parijs-aanbiedingen/"
        },
        {
          label: "Flexibel omboeken of annuleren",
          url: "https://www.holidayguru.nl/vakantie-gratis-omboeken-annuleren/"
        },
        {
          label: "Zomervakantie aanbiedingen",
          url: "https://www.holidayguru.nl/zomervakantie/"
        },
        {
          label: "Pretparken",
          url: "https://www.holidayguru.nl/pretparken/"
        },
        {
          label: "Verrassingsreis",
          url: "https://www.holidayguru.nl/verrassingsreis/"
        },
        {
          label: "Vroegboekkorting",
          url: "https://www.holidayguru.nl/vroegboekkorting/"
        },
        {
          label: "Wellness vakantie",
          url: "https://www.holidayguru.nl/wellness-aanbiedingen/"
        }
      ]
    },
    {
      label: "Vind je weg",
      links: [
        {
          label: "Vakantiebestemmingen",
          url: "https://www.holidayguru.nl/vakantiebestemmingen/"
        },
        {
          label: "Travel Magazine",
          url: "https://www.holidayguru.nl/travel-magazine/"
        },
        {
          label: "Deals per maand",
          url: "https://www.holidayguru.nl/reiskalender/vakantiebestemmingen-per-maand/"
        },
        {
          label: "Zoeken en boeken",
          url: "https://www.holidayguru.nl/zoeken-en-boeken"
        },
        {
          label: "Reisorganisaties",
          url: "https://www.holidayguru.nl/reisorganisaties-nederland/"
        },
        {
          label: "Beste reistijd",
          url: "https://www.holidayguru.nl/reiskalender/beste-reistijd/"
        },
        {
          label: "Brugdagen",
          url: "https://www.holidayguru.nl/reiskalender/feestdagen-brugdagen/"
        }
      ]
    }
  ],

  footer: {
    corporate: {
      label: "Holidayguru",
      data: [
        {
          label: "Over ons",
          url: "https://www.holidayguru.nl/over-mij/"
        },
        {
          label: "Advertising and partnerships",
          url: "https://www.holidayguru.nl/advertising-and-partnerships/"
        },
        {
          label: "Pers",
          url: "https://www.holidayguru.nl/pers/"
        },
        {
          label: "Vacatures",
          url: "https://www.holidayguru.nl/vacatures/"
        }
      ]
    },
    informations: {
      label: "Informatie",
      data: [
        {
          label: "Veelgestelde vragen",
          url: "https://www.holidayguru.nl/faq/"
        },
        {
          label: "Vakantie in coronatijden",
          url: "https://www.holidayguru.nl/vakantie-en-corona-wat-moet-je-weten/"
        },
        {
          label: "Topbestemmingen 2022",
          url: "https://www.holidayguru.nl/travel-magazine/topbestemmingen-dit-jaar/"
        },
        {
          label: "Duurzaam reizen",
          url: "https://www.holidayguru.nl/travel-magazine/duurzaam-reizen-tips/"
        }
      ]
    },
    buttons: [
      {
        label: "Privacy statement",
        url: "https://www.holidayguru.nl/privacy-statement/"
      },
      // {
      //   label: 'Sitemap',
      //   url: 'https://www.holidayguru.ch/sitemap/',
      // },
      {
        label: "Tags",
        url: "https://www.holidayguru.nl/tag/"
      },
      {
        label: "Impressum / wettelijke bepalingen",
        url: "https://www.holidayguru.nl/imprint/"
      }
    ],
    social: {
      label: "Volg Holidayguru",
      data: [
        {
          label: "Facebook",
          icon: "facebook",
          url: "https://www.facebook.com/holidayguru.nl/"
        },
        {
          label: "Instagram",
          icon: "instagram",
          url: "https://www.instagram.com/holidaygurunl/"
        },
        {
          label: "TikTok",
          icon: "tiktok",
          url: "https://www.tiktok.com/@holidayguru_nl"
        },
        {
          label: "Pinterest",
          icon: "pinterest",
          url: "https://nl.pinterest.com/holidaygurunl/"
        }
      ]
    },
    newsletter: {
      label: "Schrijf je in voor de nieuwsbrief",
      button: "Inschrijven",
      url: "https://www.holidayguru.nl/newsletter/"
    },
    app: {
      label: "Download de app",
      apple:
        "https://itunes.apple.com/nl/app/urlaubsguru-reise-schnappchen/id692735087?mt=8",
      android:
        "https://play.google.com/store/apps/details?id=de.trimexa.urlaubsguru&hl=nl-nl"
    }
  },

  jsonLD: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Holidayguru",
    url: "https://www.holidayguru.nl/",
    logo: "https://www.holidayguru.nl/wp-content/uploads/2016/04/holidayguru_277_60x2-1.png",
    sameAs: [
      "https://www.facebook.com/holidayguru.nl/",
      "https://www.instagram.com/holidaygurunl/",
      "https://www.tiktok.com/@holidayguru_nl/",
      "https://nl.pinterest.com/holidaygurunl/"
    ]
  },
  privacyManagerModalId: "547882",
  destination_category_destination: "Regio's",
  destination_category_region: "Regio's",
  destination_category_accommodation: 'Hotels',
  destination_category_city: 'Steden',
  destination_category_poi: 'Bezienswaardigheden',
  destination_category_point_of_interest: 'Bezienswaardigheden',
  destination_category_multi_city_vicinity: 'Gebieden',
  destination_category_province_state: "Regio's",
  destination_category_neighborhood: 'Omgevingen',
  destination_category_airport: 'Luchthavens',
  destination_category_train_station: 'Treinstations',
  destination_category_metro_station: 'Metrostations',
  destination_category_continent: 'Continenten',
  destination_category_country: 'Landen',
  destination_category_high_level_region: 'Gebieden',
  destination_category_favoritesdefault: 'Populaire bestemmingen',

  newsletter: {
    title: "Jouw Holidayguru nieuwsbrief",
    info: "Op zoek naar <strong>exclusieve deals en topaanbiedingen?</strong> Meld je dan aan voor de Holidayguru nieuwsbrief. <br /> <br />Dit wacht er op je:",
    listItem1: "Deals gevonden door de Holidayguru experts",
    listItem2: "Aanbiedingen met de beste prijs-kwaliteitverhouding",
    listItem3: "Inspiratie en nuttige tips voor je volgende reis",
    button: "Registreren"
  },
  amadeusPackageTourSearch: {
    infoTextSingleRoom: "Alle personen worden in één kamer ondergebracht. Als je een andere kamerindeling wenst, bel ons op:"
  }
}
